export default "__VITE_ASSET__D_u1rjs$__"